/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./resource-list.vue?vue&type=template&id=5073f2d4&scoped=true&"
import script from "./resource-list.vue?vue&type=script&lang=js&"
export * from "./resource-list.vue?vue&type=script&lang=js&"
import style0 from "./resource-list.vue?vue&type=style&index=0&id=5073f2d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5073f2d4",
  null
  
)

export default component.exports